import { lbApiBeta } from '@/utils/axiosConfig';
import { retryOnNetworkError } from '@/utils/retryOnNetworkError';

async function mockChatRoom(
  primaryPropositionId,
  propositionId,
  proposition2Id
) {
  const propositionIds = [primaryPropositionId, propositionId];
  if (proposition2Id) {
    propositionIds.push(proposition2Id);
  }

  try {
    const { data } = await lbApiBeta.post(
      '/api/messenger/chat-room/find-or-mock',
      {
        propositionIds
      }
    );
    return data;
  } catch (error) {
    return null;
  }
}

async function fetchMatchRequests(
  propositionId,
  currentSize = 0,
  chatId,
  filter
) {
  const sizeParam = `?currentSize=${currentSize}`;
  const chatIdParam = chatId ? `&chatId=${chatId}` : '';

  try {
    const { data: matchRequests } = await retryOnNetworkError(() =>
      lbApiBeta.post(
        `/api/matches/requests/filter/${propositionId}${sizeParam}${chatIdParam}`,
        filter
      )
    );
    return matchRequests;
  } catch (e) {
    window.Logger.log('FaTaL eRroR: ', e);
  }
}

async function fetchMatches(propositionId, filter, currentSize = 0, matchId) {
  const matchIdParam = matchId ? `&matchId=${matchId}` : '';
  try {
    const { data: activeMatches } = await retryOnNetworkError(() =>
      lbApiBeta.post(
        `/api/matches/filter/${propositionId}?currentSize=${currentSize}${matchIdParam}`,
        filter
      )
    );
    return activeMatches;
  } catch (e) {
    window.Logger.log('FaTaL eRroR: ', e);
  }
}

async function refetchSingleMatch(myPropositionId, matchId) {
  try {
    const { data: match } = await lbApiBeta.get(
      `/api/matches/${myPropositionId}/${matchId}`
    );
    return match;
  } catch (e) {
    window.Logger.log('FaTaL eRroR: ', e);
  }
}

async function fetchInitialMatchStatusCounts(propositionId) {
  try {
    const { data: counts } = await lbApiBeta.get(
      `/api/matches/v2/${propositionId}/summary`
    );
    return counts;
  } catch (e) {
    window.Logger.log('FaTaL eRroR: ', e);
  }
}

export default {
  mockChatRoom,
  fetchMatchRequests,
  fetchMatches,
  refetchSingleMatch,
  fetchInitialMatchStatusCounts
};
